function isChunkLoadError(error: unknown): boolean {
	if (!(error instanceof Error)) {
		return false;
	}

	const message = `${error.name} ${error.message}`.toLowerCase();

	return (
		message.includes("failed to fetch dynamically imported module") ||
		message.includes("importing a module script failed") ||
		message.includes("loading chunk") ||
		message.includes("chunkloaderror")
	);
}

export default defineNuxtPlugin(() => {
	if (import.meta.dev) {
		return;
	}

	const router = useRouter();

	router.onError((error, to) => {
		if (!isChunkLoadError(error)) {
			return;
		}

		const pathKey = to?.fullPath || window.location.pathname;
		const reloadKey = `nuxt:chunk-reload:${pathKey}`;
		const alreadyRetried = sessionStorage.getItem(reloadKey) === "1";

		if (alreadyRetried) {
			sessionStorage.removeItem(reloadKey);
			return;
		}

		sessionStorage.setItem(reloadKey, "1");
		window.location.reload();
	});
});
